export const AOJ_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://judgeapi.u-aizu.ac.jp' : `/aoj`
export const DAT_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://judgedat.u-aizu.ac.jp' : `/dat`
export const ANALYTIC_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://analytic.u-aizu.ac.jp' : `/analytic`
export const REVIEW_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://rose.u-aizu.ac.jp' : `/review`
